import { render, staticRenderFns } from "./imgSetter.vue?vue&type=template&id=38b2c39a&scoped=true"
import script from "./imgSetter.vue?vue&type=script&lang=js"
export * from "./imgSetter.vue?vue&type=script&lang=js"
import style0 from "./imgSetter.vue?vue&type=style&index=0&id=38b2c39a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38b2c39a",
  null
  
)

export default component.exports